// Needed until we update the native embedded slideware browsers which don't support EventTarget yet
import EventTarget from '@ungap/event-target'

const eventsEmitter = new EventTarget()

export const TRANSPORT_EVENTS = {
  CONNECTED: 'connected',
  OPENED: 'opened',
  CLOSED: 'closed',
  ERROR: 'error'
} as const
type EventKeys = keyof typeof TRANSPORT_EVENTS
type EventNames = typeof TRANSPORT_EVENTS[EventKeys]

export const transportEvents = {
  on (ev: EventNames, handler: Parameters<typeof eventsEmitter['addEventListener']>[1]) { eventsEmitter.addEventListener(ev, handler) },
  off (ev: EventNames, handler: Parameters<typeof eventsEmitter['removeEventListener']>[1]) { eventsEmitter.removeEventListener(ev, handler) },
  once (ev: EventNames, handler: Parameters<typeof eventsEmitter['addEventListener']>[1]) { eventsEmitter.addEventListener(ev, handler, { once: true }) }
}

export function dispatch (name: EventNames, detail: Record<string, any> = {}) {
  eventsEmitter.dispatchEvent(new CustomEvent(name, { detail }))
}
